import { gql } from '@apollo/client';

// GraphQL Query - ContactMerrillLynchDataNode / contact.ml.data
export const GET_CONTACT_MERRILL_LYNCH = gql`
  query GetContactMerrillLynchDataByContact($contactId: ID!) {
    node(id: $contactId) {
      ... on ContactNode {
        id
        name
        mlDataIds {
          id
          mlComplex
          mlHfCityIds
          mlOffice
          mlPeCityIds
          mlRegion
          mlRegionalCoverageIds
        }
      }
    }
  }
`;

// Query for ML Coverage Cities options
export const GET_ML_COVERAGE_CITIES = gql`
  query GetMlCoverageCities {
    mlCoverageCities {
      id
      name
      dynamicsValue
    }
  }
`;

// Query for ML Regional Coverage options
export const GET_ML_REGIONAL_COVERAGE_OPTIONS = gql`
  query GetMlRegionalCoverageOptions {
    mlRegionalCoverageOptions {
      id
      name
      dynamicsValue
    }
  }
`;

// UI Data Types
export interface ContactMerrillLynchData {
  mlComplex: string;
  mlHfCityIds: string[]; // Array of global IDs
  mlOffice: string;
  mlPeCityIds: string[]; // Array of global IDs
  mlRegion: string;
  mlRegionalCoverageIds: string[]; // Array of global IDs
}

export interface ContactNodeWithMerrillLynch {
  id: string;
  mlDataIds?: MerrillLynchNode | MerrillLynchNode[] | null;
  name: string;
}

export interface GetContactMerrillLynchData {
  node: ContactNodeWithMerrillLynch | null;
}

export interface GetContactMerrillLynchVariables {
  contactId: string;
}

// API Response Types - ContactMerrillLynchDataNode
export interface MerrillLynchNode {
  id: string;
  mlComplex?: null | string;
  mlHfCityIds?: null | string[]; // Array of global IDs
  mlOffice?: null | string;
  mlPeCityIds?: null | string[]; // Array of global IDs
  mlRegion?: null | string;
  mlRegionalCoverageIds?: null | string[]; // Array of global IDs
}

export interface MlCoverageCitiesData {
  mlCoverageCities: MlCoverageCity[];
}

// Option types
export interface MlCoverageCity {
  dynamicsValue: number;
  id: string;
  name: string;
}

export interface MlRegionalCoverageOption {
  dynamicsValue: number;
  id: string;
  name: string;
}

export interface MlRegionalCoverageOptionsData {
  mlRegionalCoverageOptions: MlRegionalCoverageOption[];
}

// Helper functions
export function createEmptyContactMerrillLynchData(): ContactMerrillLynchData {
  return {
    mlComplex: '',
    mlHfCityIds: [],
    mlOffice: '',
    mlPeCityIds: [],
    mlRegion: '',
    mlRegionalCoverageIds: []
  };
}

export function mapContactMerrillLynch(
  node: MerrillLynchNode
): ContactMerrillLynchData {
  return {
    mlComplex: node.mlComplex ?? '',
    mlHfCityIds: node.mlHfCityIds ?? [],
    mlOffice: node.mlOffice ?? '',
    mlPeCityIds: node.mlPeCityIds ?? [],
    mlRegion: node.mlRegion ?? '',
    mlRegionalCoverageIds: node.mlRegionalCoverageIds ?? []
  };
}

// Options for select fields
export const mlCityOptions = [
  { label: 'Boston', value: 'Boston' },
  { label: 'Chicago', value: 'Chicago' },
  { label: 'Los Angeles', value: 'Los Angeles' },
  { label: 'Miami', value: 'Miami' },
  { label: 'New York', value: 'New York' },
  { label: 'San Francisco', value: 'San Francisco' }
];

export const mlComplexOptions = [
  { label: 'Boston Complex', value: 'Boston Complex' },
  { label: 'Chicago Complex', value: 'Chicago Complex' },
  { label: 'New York Complex', value: 'New York Complex' },
  { label: 'San Francisco Complex', value: 'San Francisco Complex' }
];

export const mlOfficeOptions = [
  { label: 'Boston Financial District', value: 'Boston Financial District' },
  { label: 'Chicago Loop', value: 'Chicago Loop' },
  { label: 'Manhattan Main', value: 'Manhattan Main' },
  { label: 'SF Financial District', value: 'SF Financial District' }
];

export const mlRegionalCoverageOptions = [
  { label: 'California', value: 'California' },
  { label: 'Connecticut', value: 'Connecticut' },
  { label: 'Illinois', value: 'Illinois' },
  { label: 'Massachusetts', value: 'Massachusetts' },
  { label: 'New Jersey', value: 'New Jersey' },
  { label: 'New York', value: 'New York' }
];

export const mlRegionOptions = [
  { label: 'Midwest', value: 'Midwest' },
  { label: 'Northeast', value: 'Northeast' },
  { label: 'Southeast', value: 'Southeast' },
  { label: 'West', value: 'West' }
];
